import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "home-echarts-header",
  style: {"padding":"10px 24px 0 24px","height":"auto"}
}
const _hoisted_2 = { class: "home-echarts-header__title" }

import type { PropType, Ref } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import { computed, onBeforeMount, ref, toRef, watch } from 'vue'
import { getVisitCustomerCompletion } from '@/api/gucangSales/regionDataBoard'
import { colors } from '../../dataConfig'


const __default__ = { name: 'CustomerVisitCompletionStatus' }

interface ApiDataType {
  potentialVisitTarget?: number, // 潜在拜访目标
  potentialVisitCompleted?: number, // 潜在拜访完成
  contractVisitTarget?: number, // 签约拜访目标
  contractVisitCompleted?: number, // 签约拜访完成
  transactionVisitTarget?: number, // 成交拜访目标
  transactionVisitCompleted?: number, // 成交拜访完成
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String as PropType<string>,
    default: '客户拜访完成情况'
  },
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_lbu'>,
    required: true
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '350px'
  },
  marginBottom: {
    type: String as PropType<string>,
    default: '8px'
  },
  formState: {
    type: Object as PropType<Object>
  }
},
  setup(__props) {

const props = __props
watch(() => props.formState, (newValue) => {
  getData()
})
const spinning = ref(false)
const showECharts = ref(false)
const getData = () => {
  spinning.value = true
  getVisitCustomerCompletion(props.formState).then((res) => {
    const data = res.data || []
    showECharts.value = true
    const targetList = []
    const completeList = xAxisData.map(() => [])
    props.formState.region.deptScopeInfo.forEach((employee: any) => {
      const item = data.find((ii: any) => ii.employeeNo === employee.employeeNo)
      const total = (item?.contractVisitTarget || 0) + (item?.potentialVisitTarget || 0) + (item?.transactionVisitTarget || 0) + (item?.clueVisitTarget || 0)
      targetList.push(total)
      
      xAxisData.forEach((type, index) => {
        if (index === 0) {
          completeList[index].push(item?.clueVisitCompleted || 0)
        } else if (index === 1) {
          completeList[index].push(item?.potentialVisitCompleted || 0)
        } else if (index === 2) {
          completeList[index].push(item?.contractVisitCompleted || 0)
        } else {
          completeList[index].push(item?.transactionVisitCompleted || 0)
        }
      })
    })
    initChart(targetList, completeList)
  }).finally(() => {
    spinning.value = false
  })
}
const xAxisData = ['销售线索', '潜在客户', '签约客户', '成交客户']
const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>, undefined, false)

const initChart = (targetVisitList: any[], completeVisitList: any[]) => {
  setOptions({
    // 悬浮窗
    tooltip: {
      trigger: 'item',
      // backgroundColor: '#1D4CD2',
      // textStyle: {
      //   color: '#fff'
      // },
      // formatter: function (params) {
      //   const currentAxis = xAxisData[params.dataIndex]
      //   const targetHoverData = targetVisitList[params.dataIndex]
      //   const completionHoverData = completeVisitList[params.dataIndex]
      //   const toolsTipsResult = []
      //   toolsTipsResult.push(currentAxis)
      //   toolsTipsResult.push('拜访目标  <strong>' + targetHoverData + '</strong>')
      //   toolsTipsResult.push('实际拜访  <strong>' + completionHoverData + '</strong>')
      //   return toolsTipsResult.join('<br>')
      // }
    },
    /// 在这里配置线条颜色和legend颜色一致
    color: colors,
    legend: {
      itemWidth: 12,
      itemHeight: 2,
      left: 'right',
      icon: 'react',
      right: '50%',
      data: ['拜访目标', ...xAxisData]
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: props.formState.region.deptScopeInfo.map((item: any) => item.employeeName)
    },
    yAxis: {
      type: 'value',
      // min: 0,
      // splitLine: {
      //   show: true,
      //   lineStyle: {
      //     color: '#D8DFE4',
      //     type: 'dashed'
      //   }
      // }
    },
    series: [{data: targetVisitList, type: 'bar', name: '拜访目标', itemStyle: { color: colors[0] } }, ...completeVisitList.map((item, index) => ({
      data: item,
      type: 'bar',
      name: xAxisData[index],
      stack: 'total',
      // label: {
      //   show: true,
      //   position: 'top',
      //   formatter: '{c}%'
      // },
      itemStyle: {
        color: colors[index+1]
      }
    }))]
  })
}
onBeforeMount(() => {
  getData()
})

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_empty = _resolveComponent("dc-layout-empty")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", {
    class: "home-echarts-wrap",
    style: _normalizeStyle({ width: __props.width, height: __props.height, marginBottom: __props.marginBottom })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1)
    ]),
    _createVNode(_component_a_spin, {
      spinning: spinning.value,
      delay: 200
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "home-echarts-content"
        }, null, 512), [
          [_vShow, showECharts.value]
        ]),
        (!showECharts.value)
          ? (_openBlock(), _createBlock(_component_dc_layout_empty, {
              key: 0,
              type: "nothing"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["spinning"])
  ], 4))
}
}

})